package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.RowScope
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.outlined.ArrowBack
import androidx.compose.material.icons.outlined.Close
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.vector.ImageVector
import fr.frux.core.designsystem.resources.Res
import fr.frux.core.designsystem.resources.ds_top_bar_back
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FruxTopBar(
    title: String,
    modifier: Modifier = Modifier,
    onBack: (() -> Unit)? = null,
    /**
     * Icône de navigation, flèche retour par défaut. Un écran poussé « en formulaire modal »
     * (ex. création) préfère une croix (#167) : passer [Icons.Outlined.Close].
     */
    navigationIcon: ImageVector = Icons.AutoMirrored.Outlined.ArrowBack,
    navigationContentDescription: String = stringResource(Res.string.ds_top_bar_back),
    actions: @Composable RowScope.() -> Unit = {},
) {
    CenterAlignedTopAppBar(
        title = {
            Text(text = title, style = MaterialTheme.typography.titleLarge)
        },
        modifier = modifier,
        navigationIcon = {
            if (onBack != null) {
                FruxIconButton(
                    icon = navigationIcon,
                    contentDescription = navigationContentDescription,
                    onClick = onBack,
                )
            }
        },
        actions = actions,
        colors =
            TopAppBarDefaults.topAppBarColors(
                containerColor = MaterialTheme.colorScheme.background,
                scrolledContainerColor = MaterialTheme.colorScheme.background,
            ),
    )
}
